<script>
	import { onMount } from 'svelte'
	import NewsPosts from './news-posts.svelte'
	// import NewsColumn from './news-column.svelte'
   import { gsap } from "gsap";
   import { ScrollTrigger } from "gsap/ScrollTrigger";
   gsap.registerPlugin(ScrollTrigger)
	const jq = window.jquery

	const {featured, sections } = newsData
   // console.log(sections)

	//TODO internal sorting of featured
	// console.log(newsData)
	let query = new URLSearchParams(window.location.search)
	let activeCategory 
	if(query.get('category')) {
		activeCategory = sections.filter(s => s.slug.includes(query.get('category')))[0]
	}
	// let promise = getInsightCategories()
	// let insightCategories = []
	let posts = {
		//"slug": { "name":"", "posts":[]}, ...
	}
	// $:console.log(posts)

	async function getCategoriesPosts(section) {
		const res = await fetch(`/wp-json/theme/v1/get-news-posts?category=${section.slug}`)
		const data = await res.json()

		if (res.ok) {
			// insightCategories = data
			posts[section.slug] = data
			// if(!activeCategory) activeCategory = data[0].slug
			// return data
		} else {
			throw new Error(data.message)
		}
	}//initial preloading
	onMount(() => {
		sections.map((section) => getCategoriesPosts(section))
	})

	// async function getInsightCategories() {
	// 	const res = await fetch(`/wp-json/theme/v1/insight-subcategories`)
	// 	const data = await res.json()

	// 	if (res.ok) {
	// 		insightCategories = data
	// 		if(!activeCategory) activeCategory = data[0].slug
	// 		return data
	// 	} else {
	// 		throw new Error(data.message)
	// 	}
	// }

	function afterMount() {
		const indicator = document.querySelector('#news-insight .nav-indicator')
		const items = document.querySelectorAll('#news-insight .nav-item')
		items[0].classList.add('is-active')
		setTimeout(()=> { //proper alignment on load of activeCategory set
			if(!activeCategory) {
            // console.log(items[0])
				activeCategory = items[0].getAttribute('data-slug').replace(/\s+/g, '-').toLowerCase()//.split('(')[0].trim()
				activeCategory = sections.filter(s => s.slug.includes(activeCategory))[0]
			} else {
				handleIndicator(
					Array.from(items)
					.filter(item => {
						return item.getAttribute('data-label')
									.includes(activeCategory.slug)})[0])
			}
		}, 1000)
		//TODO https://localhost:3000/news/?tab=insight&category=scaling

		function handleIndicator(el) {
			items.forEach((item) => {
				item.classList.remove('is-active')
				item.removeAttribute('style')
			})
			// console.log(el)
			indicator.style.width = `${el.offsetWidth}px`
			indicator.style.left = `${el.offsetLeft}px`
			indicator.style.backgroundColor = el.getAttribute('active-color')

			el.classList.add('is-active')
			el.style.color = el.getAttribute('active-color')
		}

		items.forEach((item, index) => {
			item.addEventListener('click', (e) => {
				handleIndicator(e.target)
			})
			item.classList.contains('is-active') && handleIndicator(item)
		})
	}
</script>
<div class="news-wrap">
	<div class="news-featured news-section">
      <!-- <h2 class="h-underline">Featured</h2> -->
      <!-- {#await promise}
         <p>Loading...</p>
      {:then} -->
         <div class="news-grid">
         {#each featured as post}
            <div class="news-post rel">
					<a class="fillall" href="{post.url}"><span class="sr-only">View {post.name}</span></a>
               <div class="new-post-image" style="background-image: url({post.img}})"></div>
               <div class="new-post-content">
						<!-- <p class="post-category">
							{post.category.name}
						</p> -->
						<a class="red" style=" position: relative; z-index: 1;" href="/category/{post.category.slug}">
                     <span class="">{post.category.name}</span>
                  </a>
                  <h3>{@html post.name}</h3>
                  <p class="post-source">{post.source}</p>
               </div>
            </div>
         {/each}
         </div>
      <!-- {:catch error}
         <p style="color: red">{error.message}</p>
      {/await} -->
   </div>
	<!-- <NewsInsight /> -->
	{#if sections.length}
	<div id="news-insight">
		<!-- <div class="insight-nav in-page-tabs">
			<nav class="nav">
				{#each sections as category}
					<a
						href={''}
						data-slug={category.slug}
						class="nav-item"
						active-color={'#A93333'}
						data-label={category.slug}
						on:click={(e) => {
							e.preventDefault()
							// gsap.to('.news-section:not(.news-featured) .news-post', {opacity: 0, duration:0.35, stagger:0.1, ease:'power1.out', y:20})
							// setTimeout(() => {
                     activeCategory = category
                     history.replaceState(null, null, location.href.split('#')[0].split('?')[0]+`?category=${activeCategory.slug}`)
							// }, 500)
						}}
					>
						{category.name}
						{posts[category.slug] ? `(${posts[category.slug].length})` : '(  )'}</a
					>
				{/each}
				<span class="nav-indicator" aria-hidden="true" />
			</nav>
		</div> -->
	
		<!-- {#await promise}
			<p>Loading...</p>
		{:then} -->
		<div>
         {#each sections as category}
            <div class="d-flex justify-content-between">
               <h2>{category.name}</h2>
               <a href="/category/{category.slug}" class="btn outlined-btn">{category.name}</a>
            </div>
				{#if posts[category.slug]}
					<NewsPosts posts={posts[category.slug]} category={category} />
				{/if}
			{/each}
		</div>
		<!-- {:catch error}
			<p style="color: red">{error.message}</p>
		{/await} -->
	</div>	
	{/if}
</div>